import React, { useCallback, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import BetSlipContext from "../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
// import StackSetting from "./StackSetting";
import { isEmpty } from "lodash";
import { usePolling } from "../../component/usePolling";
import DialVelkie from "./DialVelkie";
import DialNew from "./DialNew";
// import ParlayDial from "./ParlayDial";

const BetSlipParlayVelkie = () => {
  let betCheckObj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };

  const setShowParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowParlyBet;
  });
  const showParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.showParlyBet;
  });
  const setParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setParlyBet;
  });
  const parlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlyBet;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const setBetLoader = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetLoader;
  });

  const [stake, setStake] = useState("");
  const [showDial, setShowDial] = useState(false);
  const [totalOdds, setTotalOdds] = useState("");
  const [setting, setSetting] = useState(false);
  const [loader, setLoader] = useState(false);

  const removeSlip = (id) => {
    setParlyBet((current) => {
      if (current?.length == 1) {
        secureLocalStorage.setItem("parlyBet", []);
      } else {
        secureLocalStorage.setItem(
          "parlyBet",
          current?.filter((res) => {
            return res?.newEventId !== id;
          })
        );
      }
      return current?.filter((res) => {
        return res?.newEventId !== id;
      });
    });
    if (parlyBet?.length == 1) {
      setShowParlyBet(false);
    }
  };

  const handelDialPad = (item) => {
    let str = stake?.toString() + item?.toString();
    if (str?.length > 6) {
    } else {
      setStake(Number(str));
    }
  };

  useEffect(() => {
    if (parlyBet?.length > 0 && showParlyBet) {
      setTotalOdds(
        parlyBet
          ?.filter((res) => !res?.closed)
          ?.reduce(
            (accumulator, currentValue) =>
              accumulator * currentValue?.sportsBookSelectionObject?.odds,
            1
          )
          ?.toFixed(2)
      );
    }
  }, [parlyBet, showParlyBet]);

  const getOdds = async () => {
    const eventIds =
      parlyBet?.map((res) => res?.betfairEventId).join(",") || "";
    if (!eventIds) return;

    const { status, data } = await apiGet(
      `${apiPath.getPremiumFancy}?events=${eventIds}&multi=true`
    );

    if (status !== 200 || !data?.success) return;

    setParlyBet((current) => {
      const results = data?.results || [];
      const updatedBets = current.map((item) => {
        // Find matching result object for the current item
        const obj = results.find(
          (res) => res?.eventId === item?.eventId && res?.id === item?.id
        );
        if (isEmpty(obj) || obj?.sportsBookSelection?.length == 0) {
          return { ...item, closed: true }; // No data → close this bet
        }

        // Find the selected inner object
        const innerObj = obj.sportsBookSelection.find(
          (pop) => pop?.id === item?.sportsBookSelectionObject?.id
        );
        const isClosed =
          obj?.apiSiteStatus === "SUSPENDED" ||
          Number(obj?.marketStatus) !== 1 ||
          Number(innerObj?.isActive) !== 1;
        // Merge necessary fields dynamically instead of manually rewriting all keys

        return {
          ...obj,
          sportsBookSelectionObject: innerObj,
          selectObj: obj?.selectObj,
          spark: getSparkColor(
            innerObj?.odds,
            item?.sportsBookSelectionObject?.odds,
            item?.spark
          ),
          newEventId: item?.newEventId,
          eventName: item?.eventName,
          marketId: item?.marketId,
          closed: isClosed,
          eventType: item?.eventType,
        };
      });

      secureLocalStorage.setItem("parlyBet", updatedBets);
      return updatedBets;
    });
  };
  const getSparkColor = (newOdds, oldOdds, prevSpark) => {
    if (newOdds > oldOdds) return "green";
    if (newOdds < oldOdds) return "red";
    if (newOdds === oldOdds) return prevSpark;
    return "";
  };
  const fetchPremium = useCallback(async () => {
    if (showParlyBet) {
      await getOdds();
    }
  }, [showParlyBet]);

  usePolling(fetchPremium, 4000, showParlyBet);

  const clear = () => {
    let str = stake?.toString();
    if (str?.length == 1) {
      setStake("");
    } else {
      setStake(str.substring(0, str.length - 1));
    }
  };

  const placeBet = async () => {
    if (!parlyBet || parlyBet.length < 2) {
      setToastObject({
        type: "error",
        title: "Bet Error",
        message: "Please select at least 2 parlay bets",
        status: true,
      });
      return;
    }

    setBetLoader(true);

    // Find bets that are closed
    const closedBets = parlyBet.filter((res) => res?.closed);

    // If any bets are closed, show error and stop execution
    if (closedBets.length > 0) {
      setToastObject({
        type: "error",
        title: "Bet Error",
        message: `Market are closed ${closedBets
          .map((res) => res?.eventId)
          .join(", ")}`,
        status: true,
      });
      return;
    }
    setLoader(true);
    // Prepare date & payload data
    const betPlaceTime = moment().format("YYYY-MM-DD, h:mm:ss");
    const resultArray = parlyBet.map((res) => ({
      eventId: res?.newEventId,
      marketId: res?.marketId,
      fancySelectionId: res?.sportsBookSelectionObject?.id,
      selectionId: res?.id,
      betPlaceTime,
      fancyName: res?.marketName,
      bhav: res?.sportsBookSelectionObject?.odds,
      betType: "back",
      runnerName: res?.sportsBookSelectionObject?.selectionName,
      apiSiteSelectionId: res?.sportsBookSelectionObject?.apiSiteSelectionId,
      betPlaceType: "premiumFancy",
    }));

    const payload = {
      betPlaceTime,
      overallOdds: totalOdds,
      totalAmount: stake,
      bets: resultArray,
    };

    // Send API request
    const { status, data } = await apiPost(apiPath.multiEventPlaceBet, payload);

    if (status === 200 && data?.success) {
      setToastObject({
        type: "success",
        title: "Bet Placed",
        message: `Total Stake BDT ${stake} | Max Profit ${totalOdds > 0 && stake > 0 ? ((totalOdds - 1) * stake)?.toFixed(2) : 0
          }`,
        status: true,
      });
      amounutRefresh();
      setParlyBet([]);
      setShowParlyBet(false);
    } else {
      setToastObject({
        type: "error",
        title: "Bet Error",
        message: data?.message,
        status: true,
      });
    }
    setLoader(false);
  };
  return (
    <div data-v-b1b92075>
      <div
        data-v-b1b92075
        className="absolute top-0 w-full h-full z-40"
        style={{ display: showParlyBet ? "block" : "none" }}
      />
      <div
        data-v-b1b92075
        className="bet-slip fixed z-40 container bottom-0 shadow-top rounded-t-xl"
        style={{ display: showParlyBet ? "block" : "none" }}
      >
        <div data-v-b1b92075 className="relative bg-white pt-2 rounded-t-xl">
          <header data-v-b1b92075 className="relative font-bold mb-2">
            <p
              data-v-b1b92075
              className="global-font-on-light text-18 text-center p-2"
            >
              Bet Slip
            </p>
            <div
              onClick={() => setShowParlyBet(false)}
              data-v-b1b92075
              className="icon-close absolute right-5 top-2 text-black text-base cursor-pointer"
            />
          </header>
          <div data-v-b1b92075 className="divide-y divide-black-300">
            <div data-v-b1b92075 className="item1 max-h-72 overflow-y-scroll">
              {parlyBet?.length > 0
                ? parlyBet?.map((res) => {
                  return (
                    <div data-v-b1b92075 className="w-full mb-2 px-2">
                      <div
                        data-v-b1b92075
                        className={`px-1 w-full flex items-center bg-black-300 ${res?.closed ? "rounded-lg" : "rounded-t-lg"
                          } `}
                      >
                        {res?.closed && (
                          <span
                            data-v-b1b92075
                            className="my-4px bg-black-600 leading-5 py-1 mr-2 text-black-300 px-2 rounded font-bold text-13"
                          >
                            Closed
                          </span>
                        )}
                        <div
                          data-v-b1b92075
                          className={
                            res?.closed
                              ? "text-black-400 py-4px px-1 w-full text-13"
                              : "text-black py-2 px-1 w-full text-13"
                          }
                        >
                          <span data-v-b1b92075 className="leading-tight">
                            {betCheckObj[res?.eventType]}
                          </span>
                          <span data-v-b1b92075>
                            <i
                              data-v-b1b92075
                              className="icon-triangle-black-600 text-8 inline-block align-middle"
                            />
                          </span>
                          <span
                            data-v-b1b92075
                            className="break-all leading-16px"
                          >
                            <span data-v-b1b92075 className="font-bold">
                              {res?.eventName}
                            </span>
                          </span>
                        </div>
                        <i
                          onClick={() => removeSlip(res?.newEventId)}
                          data-v-b1b92075
                          className="self-center icon-del inline-block px-1.5 text-18 text-black-600"
                        />
                      </div>
                      {!res?.closed && (
                        <div
                          data-v-b1b92075
                          className="p-2 w-full bg-black-100 rounded-b-lg"
                        >
                          <div className="relative mb-2 flex justify-between items-center">
                            <p className="w-10/12 text-15 text-black font-bold break-all">
                              {res?.sportsBookSelectionObject?.selectionName}
                            </p>
                            <div className="relative w-48px h-27px flex justify-center items-center text-15 text-center font-bold bg-black-300 rounded">
                              <span className="text-parlay">
                                {" "}
                                {res?.sportsBookSelectionObject?.odds}
                              </span>
                            </div>
                            {/* <span className="absolute text-10 top-0.5 right-0.5 icon-parlay-up text-parlay-up scale-75" /> */}
                          </div>
                          <p className="text-10 text-black">
                            {res?.marketName}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                })
                : []}
            </div>
            <div data-v-b1b92075 className="item2 px-2">
              <div data-v-b1b92075 className="py-2 flex justify-between">
                <div
                  data-v-b1b92075
                  className="flex justify-center items-center"
                >
                  <span
                    data-v-b1b92075
                    className="mr-2 text-13 text-black font-bold"
                  >
                    Avg Odds
                  </span>
                  <span
                    data-v-b1b92075
                    className="mr-2 text-13 text-warning font-bold"
                  >
                    @
                    {parlyBet?.length > 0
                      ? totalOdds == 1
                        ? 0
                        : totalOdds
                      : 0}
                  </span>
                  <i
                    data-v-b1b92075
                    className="icon-arrow-left rotate-180 ml-2px text-6 text-parlay-up"
                  />
                  <span
                    data-v-b1b92075
                    className="text-10 text-parlay-up font-bold"
                  >
                    {totalOdds > 0 && stake > 0
                      ? ((totalOdds - 1) * stake)?.toFixed(2)
                      : 0}
                  </span>
                </div>
                <div
                  data-v-b1b92075
                  className="flex justify-center items-center"
                >
                  <span
                    data-v-b1b92075
                    className="mr-2 text-13 text-black font-bold"
                  >
                    Stake
                  </span>
                  <div
                    onClick={() => setShowDial(true)}
                    data-v-b1b92075
                    className="flex w-90px h-27px text-center leading-normal rounded"
                  >
                    <span
                      data-v-b1b92075
                      name="stake"
                      className={`input-field ${showDial ? "is-focus" : "is-default"
                        } `}
                    >
                      {" "}
                      {stake}
                    </span>
                  </div>
                </div>
              </div>
              {showDial && (
                <DialNew
                  clear={clear}
                  setShowDial={setShowDial}
                  handelDialPad={handelDialPad}
                  setSetting={setSetting}
                />
              )}
            </div>
            <div
              data-v-b1b92075
              className="item3 px-2 py-3 flex justify-between items-center"
            >
              <div data-v-b1b92075 className="py-1">
                <div data-v-b1b92075 className="mb-0.5 k">
                  <span data-v-b1b92075 className="mr-2 text-18 font-normal">
                    Total Stakes
                  </span>
                  <span data-v-b1b92075 className="text-16 font-bold" />
                </div>
                <div data-v-b1b92075 className="text-base">
                  <span data-v-b1b92075 className="mr-2 font-normal">
                    Max Profit
                  </span>
                  <span data-v-b1b92075 className="font-bold">
                    {totalOdds > 0 && stake > 0
                      ? ((totalOdds - 1) * stake)?.toFixed(2)
                      : 0}
                  </span>
                </div>
              </div>
              <button
                onClick={() => placeBet()}
                disabled={stake > 0 && parlyBet?.length > 0 ? false : true}
                data-v-b1b92075
                className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed w-181px h-50px flex justify-center items-center rounded-md bg-button-normal"
                type="submit"
              >
                Place Bet
              </button>
            </div>
            <div
              data-v-b1b92075
              className="item4 p-2 flex justify-between items-center"
            >
              <div
                data-v-b0cd02b4
                data-v-b1b92075
                className="text-11 text-black-900"
              >
                <input
                  data-v-b0cd02b4
                  id="accept-any-odds"
                  name="accept-any-odds"
                  type="checkbox"
                  className="hidden"
                />
                <label
                  data-v-b0cd02b4
                  htmlFor="accept-any-odds"
                  className="flex justify-start items-center select-none"
                >
                  <span
                    data-v-b0cd02b4
                    className="flex justify-center items-center border border-solid border-checkbox-boder mr-1.5 w-4 h-4 rounded bg-checkbox-checked"
                  >
                    <span
                      data-v-b0cd02b4
                      className="icon-check text-checkbox-icon text-8 font-bold"
                    />
                  </span>
                  <div data-v-b0cd02b4>Accept any odds </div>
                </label>
              </div>
              <div data-v-b1b92075 className="flex items-center space-x-1">
                <mark
                  data-v-b1b92075
                  className="text-11 bg-black-300 text-black leading-normal px-2 rounded"
                >
                  Max
                </mark>
                <span
                  data-v-b1b92075
                  className="text-11 text-black-600 font-bold"
                />
              </div>
            </div>
          </div>
          <div
            data-v-b1b92075
            className="loading absolute z-10 top-0 left-0 w-full h-full flex items-center justify-center bg-black-800 bg-opacity-87 rounded-t-xl"
            style={loader ? {} : { display: "none" }}
          >
            <img
              data-v-b1b92075
              width={147}
              height={124}
              src={require("../../assets/images/loading-bet.webp")}
              alt
            />
          </div>
        </div>
      </div>
      {setting && <DialVelkie handleStackSetting={setSetting} />}
    </div>
  );
};

export default BetSlipParlayVelkie;
